module.exports = __webpack_public_path__ + "img/loading-dots.7a018d2e.gif";